export const SETTING_BUCKET = 'bucket'
export const SETTING_LABEL = 'label'
export const SETTING_MEMBERSHIP_LABEL = 'membership_label'
export const SETTING_WEBHOOK_ESP_LIST = 'webhook_esp_list'
export const SETTING_CAMPAIGN_SEGMENT_LIST = 'campaign_segment_list'
